import React from "react";
import { CardContent, Typography } from "@material-ui/core";
import { AdminUserDetailsResponse } from "../../../../../../services/user-admin/types/api/user-details-response";
import {
  CardLoading,
  CardLoadingProps,
} from "../../../components/card-loading";

interface UserAccountStatusProps extends CardLoadingProps {
  user: AdminUserDetailsResponse;
}

export const UserAccountStatus: React.FC<UserAccountStatusProps> = ({
  user,
  ...props
}) => {
  return (
    <CardLoading {...props}>
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Account Status
        </Typography>
        {!user.enabled ? (
          <Typography variant="h5" component="h2" color="secondary">
            DISABLED
          </Typography>
        ) : null}
        <Typography color={user.active ? "primary" : "secondary"}>
          {user.active ? "Verified" : "Not Verified"}
        </Typography>
      </CardContent>
    </CardLoading>
  );
};
